import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { specialEventSystemMessage, textMessageStyle } from './styles.ts';

import { MessageUI } from '@/api/messaging/types.ts';
import { MessageTypes } from '@/enums/apiEnums.ts';
import { ViewMessageType } from '@/enums/viewEnums.ts';
import FireMultiShape from '@/components/common/svg/shapes/reactions/FireMultiShape.tsx';
import HeartStickerShape from '@/components/common/svg/shapes/reactions/HeartStickerShape.tsx';
import TwoHeartsShape from '@/components/common/svg/shapes/TwoHeartsShape.tsx';

interface MessageContentProps {
  message: MessageUI;
  messageType: ViewMessageType;
}

const MessageContent: FC<MessageContentProps> = ({ message, messageType }) => {
  const { t } = useTranslation();

  if (messageType === ViewMessageType.MATCH) {
    return (
      <div style={{ ...specialEventSystemMessage, marginBottom: 10 }}>
        <TwoHeartsShape
          width={20}
          height={20}
          fillColor="#bc4141"
          style={{
            flexShrink: 0,
            marginRight: 4,
            display: 'block'
          }}
        />
        <div style={{ color: '#ffffff' }}>{t('message.new_match')}</div>
      </div>
    );
  }

  if (message.type === MessageTypes.TYPE_STICKER && message.sticker_body) {
    return <HeartStickerShape width={80} height={80} />;
  }

  if (
    message.type === MessageTypes.TYPE_ICEBREAKER_GIFT &&
    message.icebreaker_gift
  ) {
    const giftStyle = { paddingTop: '10px' };
    return <FireMultiShape style={giftStyle} />;
  }

  if (message.type === MessageTypes.TYPE_BAIT && message.bait_body) {
    return (
      <div style={textMessageStyle}>{message.bait_body?.message ?? ''}</div>
    );
  }

  return <div style={textMessageStyle}>{message.text_body?.message ?? ''}</div>;
};

export default MessageContent;
